import localStore from '@/localStore';

/*

  STATE

 */

const state = {
  routeName: '',
  routeParam: '',
  routeMeta: {},
  currentId: '',
  currentSet: [],
  currentSetName: '',
  currentIndex: null,
  parentSet: [],
  parentSetName: '',
  parentIndex: null,
  snack: {
    text: '',
    actionText: '',
    handler: null,
    keepOpen: false,
    quick: false,
  },
};

/*

  GETTERS

 */

const getters = {
  layout: state => state.routeMeta.layout || 'default',
  routeLoaded: state => state.routeName !== '' && state.routeName !== null,
  isLanding: state => state.routeName === 'Landing',
  isContentView: state => !!state.routeMeta.isContentView,
  isStoreView: state => !!state.routeMeta.isStoreView,
  isAdminView: state => !!state.routeMeta.isAdminView,
  isDailyCardView: state => state.currentSetName === 'dailyCards',

  currentCategory: (state, getters, rootState) => {
    const { routeName, routeParam, currentId } = state;
    const currentCard = rootState.cards.allCards[currentId];
    let category = 'journey';
    if (routeName === 'Category') {
      category = routeParam;
    } else if (routeName === 'Card' && currentCard) {
      category = currentCard.category; // eslint-disable-line
    }
    return category;
  },
};

/*

  ACTIONS

 */

const actions = {
  parseRoute({ commit, dispatch, state, getters }, { name, params, meta, path }) {
    let param = '';

    if (name === 'Category') {
      param = params.category || '';
    } else if (name === 'Welcome') {
      dispatch('updateWelcomeSet');
      commit('setCurrentId', 1);
    } else if (meta.isContentView) {
      param = params.id || '';
      commit('setCurrentId', param);
      if (state.currentIndex === null) {
        dispatch('getSavedSet', param);
      }
    } else if (meta.isAdminView) {
      param = params.page || '';
    }

    commit('setCurrentRoute', { name, param, meta });

    if (getters.isDailyCardView) {
      dispatch('dailyCards/updateViewedTime', param, { root: true });
    }
    if (name === 'Stack') {
      dispatch('updateStackSet');
    }

    dispatch('analytics/sendView', { name, param, path }, { root: true });
    // console.log('$route', name, param);
  },

  updateCurrentSet({ commit }, { set, setName, index }) {
    if (set) {
      commit('setCurrentSet', { set, setName, index });
      // Save current set in case of page refresh
      localStore.setItem('currentSet', { set, setName });
    }
  },

  updateParentSet({ commit }, { set, setName, index }) {
    if (set) {
      commit('setParentSet', { set, setName, index });
    }
  },

  updateWelcomeSet({ dispatch }) {
    dispatch('updateCurrentSet', {
      set: ['welcome-1', 'welcome-2', 'welcome-3'],
      setName: 'welcome',
      index: 0,
    });
  },

  updateStackSet({ state, dispatch }) {
    const { parentSet: set, parentSetName: setName, parentIndex: index } = state;
    if (index === null) {
      dispatch('updateCurrentSet', {
        set: [state.currentId],
        setName: '',
        index: 0,
      });
    } else {
      dispatch('updateCurrentSet', { set, setName, index });
    }
  },

  clearCurrentSet({ commit, dispatch }) {
    dispatch('updateCurrentSet', {
      set: [''],
      setName: '',
      index: 0,
    });
    commit('setCurrentId', '');
  },

  getSavedSet({ dispatch }, id) {
    if (!id) {
      dispatch('clearCurrentSet');
      return;
    }
    const savedSet = localStore.getItem('currentSet');
    if (savedSet) {
      let { set, setName } = savedSet;
      let index = set.indexOf(id);
      if (index === -1) {
        set = [id];
        setName = '';
        index = 0;
      }
      dispatch('updateCurrentSet', { set, setName, index });
    }
  },

  updateSnack(
    { commit },
    { text = '', actionText = '', handler = null, keepOpen = false, quick = false }
  ) {
    commit('setSnack', { text, actionText, handler, keepOpen, quick });
  },
};

/*

  MUTATIONS

 */

const mutations = {
  setCurrentRoute(state, { name, param, meta }) {
    state.routeName = name;
    state.routeParam = param;
    state.routeMeta = meta;
  },

  setCurrentId(state, id) {
    state.currentId = id;
  },

  setCurrentSet(state, { set, setName, index }) {
    state.currentSet = set;
    state.currentSetName = setName;
    state.currentIndex = index;
  },

  setParentSet(state, { set, setName, index }) {
    state.parentSet = set;
    state.parentSetName = setName;
    state.parentIndex = index;
  },

  setCurrentIndex(state, index) {
    const { routeName } = state;
    state.currentIndex = index;
    if (routeName === 'Stack') {
      state.parentIndex = index;
    }
  },

  setSnackText(state, text) {
    state.snackText = text;
  },

  setSnack(state, snack) {
    state.snack = snack;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
